import { ClaimChecklistItem, LineOfBusiness } from './domain.models';

/** Illustrative claim types and documentation checklists per type (spec P-61, "a confirmar"). */
export const CLAIM_TYPES: Record<LineOfBusiness, string[]> = {
  auto: ['Choque', 'Robo total', 'Robo parcial', 'Incendio', 'Granizo', 'Cristales'],
  home: ['Robo', 'Incendio', 'Daños por agua', 'Responsabilidad civil'],
  commerce: ['Robo', 'Incendio', 'Daños por agua', 'Responsabilidad civil'],
  liability: ['Responsabilidad civil'],
  'personal-accident': ['Accidente'],
  life: ['Fallecimiento'],
};

const POLICE = { key: 'police-report', label: 'Denuncia policial' };
const PHOTOS = { key: 'photos', label: 'Fotos del daño' };
const ID_DOCS = { key: 'id-docs', label: 'Registro y cédula' };
const QUOTE = { key: 'repair-quote', label: 'Presupuesto de reparación' };
const INVENTORY = { key: 'inventory', label: 'Detalle de lo robado o dañado' };
const GENERIC = [{ key: 'statement', label: 'Declaración firmada del asegurado' }, PHOTOS];

const BY_TYPE: Record<string, { key: string; label: string }[]> = {
  Choque: [POLICE, PHOTOS, ID_DOCS, QUOTE],
  'Robo total': [POLICE, ID_DOCS, { key: 'keys', label: 'Llaves y título del vehículo' }],
  'Robo parcial': [POLICE, PHOTOS, QUOTE],
  Incendio: [{ key: 'fire-report', label: 'Informe de bomberos' }, PHOTOS, QUOTE],
  Granizo: [PHOTOS, QUOTE],
  Cristales: [PHOTOS, QUOTE],
  Robo: [POLICE, INVENTORY],
  'Daños por agua': [PHOTOS, INVENTORY, QUOTE],
};

export function checklistFor(type: string): { key: string; label: string }[] {
  return BY_TYPE[type] ?? GENERIC;
}

export function pendingChecklist(type: string): ClaimChecklistItem[] {
  return checklistFor(type).map(item => ({ ...item, received: false, receivedDate: null }));
}
